type LogoProps = {
  className?: string;
  size?: number;
};

export const Logo = ({ className = '', size = 72 }: LogoProps) => {
  return (
    <img
      src="/coenergy-logo.png"
      alt="COENERGY"
      className={`app-logo ${className}`.trim()}
      width={size}
      height={size}
    />
  );
};
